import { CurrencyDollarIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";
import {
  MaskedFormInput,
  type MaskedFormInputProps,
} from "@/core/components/masked-form-input";
import { getValidDollarAmountMask } from "@/core/masks/currency-masks";

export interface MoneyInputProps
  extends Omit<MaskedFormInputProps, "maskOptions"> {
  includeDollarSymbol?: boolean;
}

export const MoneyInput = ({
  value,
  onChange,
  startAdornment = <CurrencyDollarIcon className="h-6 w-6" />,
  includeDollarSymbol = false,
  ...props
}: MoneyInputProps) => {
  const maskOptions = useMemo(
    () => getValidDollarAmountMask(includeDollarSymbol),
    [includeDollarSymbol],
  );

  return (
    <MaskedFormInput
      value={value}
      onChange={onChange}
      startAdornment={startAdornment}
      maskOptions={maskOptions}
      {...props}
    />
  );
};
